
import {defineComponent} from 'vue';
import {AlertType, TYPE_DEFAULT, TYPES, ICON_MAP} from './types';
import Text from '@ohrm/oxd/core/components/Text/Text.vue';
import Icon from '@ohrm/oxd/core/components/Icon/Icon.vue';
export default defineComponent({
  name: 'oxd-alert',

  components: {
    'oxd-text': Text,
    'oxd-icon': Icon,
  },

  props: {
    type: {
      type: String,
      default: TYPE_DEFAULT,
      validator: function(value: AlertType) {
        return TYPES.indexOf(value) !== -1;
      },
    },
    message: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: false,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes(): object {
      return {
        'oxd-alert': true,
        [`oxd-alert--${this.type}`]: true,
      };
    },
    contentClasses(): object {
      return {
        'oxd-alert-content': true,
        [`oxd-alert-content--${this.type}`]: true,
      };
    },
    iconName(): string {
      return this.icon ? this.icon : ICON_MAP[this.type as AlertType];
    },
  },
});
